export default __webpack_public_path__ + "static/media/half-to-half-image.2d7f9725.png";